import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class UserService extends CrudService {
  constructor() {
    super(API_RESOURCE.USER)
  }

  uploadUser = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }

  uploadVendorUsers = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/uploadVendor`, form)

    return response.data
  }

  activateUser = async ({ id }) => {
    const response = await axios.put(`${this.resource}/${id}/activate`)

    return response.data
  }

  // fetchAll = (parameter) => {
  //   console.log('parameter', parameter)
  //   return { data: [] }
  // }
}

export default UserService
